//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';

export default {
    name: "broadcastDetail",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            detail: {}
        }
    },
    methods: {
        getBroadcasting() {
            abp.ajax.get('/api/services/app/Broadcasting/GetBroadcastingById/?id=' + this.id).then(res => {
                this.detail = {};
                this.detail = res.data.result;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getBroadcasting();

    }
}
